module.exports = __webpack_public_path__ + "static/media/lvjian-nanjingligong.cfdfb1e8.jpg";